import { AboutPanel } from "./about-panel";

export { AboutPanel }
